<template>
  <v-dialog v-model="show" persistent max-width="600">
    <v-card rounded="xl"  prepend-icon="mdi-alert" :title="message.title">
          <v-container>
            <v-card-text v-html="htmlText"></v-card-text>
            <v-text-field :label="'*'+confirmationText" variant="outlined" v-model="textInput"></v-text-field>
          </v-container>
      <v-divider class="my-3"></v-divider>
      <v-card-actions>
        <v-btn variant="text" color="primary" @click="handleResponse()">Cancel</v-btn>
        <v-btn color="primary" @click="handleResponse(textInput)">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DOMPurify from 'dompurify';
export default {
    name: "ConfirmationText",
  data() {
    return {
      show: false,
      message: { title: '', text: '' },
      textInput: '',
      confirmationText: '',
      _resolver: null,
      htmlText: '',
    };
  },
  methods: {
    open(msg) {
      this.message = { title: msg.title || '', text: msg.text || '' };
      this.confirmationText = msg.confirmationText || '';
      this.textInput = '';
      const raw = (this.message.text || '').toString();
      const withBreaks = raw.replace(/\r\n|\r|\n/g, '<br/>');
      this.htmlText = DOMPurify.sanitize(withBreaks);
      this.show = true;
      return new Promise((resolve) => {
        this._resolver = resolve;
      });
    },
    handleResponse(value) {
        console.log( this.confirmationText);
        console.log(value);
        let result = value === this.confirmationText;
        if (this._resolver) {
            this._resolver(result);
            this._resolver = null;
        }
        this.show = false;
    },
  },
  beforeUnmount() {
    this._resolver = null;
    this.message = { title: '', text: '' };
    this.textInput = '';
    this.confirmationText = '';

  },
};
</script>